// @flow
import React from 'react';
import {
  AutoSizer, List,
} from 'react-virtualized';

import {
  scrollbarSize,
} from 'chronos-utils';


function calculateHeight(props, ASheight) {
  const { subtractHorizontalScrollbar, height } = props;
  let realHeight = height || ASheight;
  realHeight -= subtractHorizontalScrollbar ? scrollbarSize : 0;
  return realHeight;
}

function calculateWidth(props, ASwidth) {
  const { subtractVerticalScrollbar, width } = props;
  let realWidth = width || ASwidth;
  realWidth -= subtractVerticalScrollbar ? scrollbarSize : 0;
  return realWidth;
}

type Props = {
  width: number,
  height: number,
  fetching: boolean,
};

const VirtualList = (props: Props) => (
  <AutoSizer>
    {({ height, width }) => (
      <div style={{ height: props.height || height, width: props.width || width }}>
        <List
          {...props}
          width={calculateWidth(props, width)}
          height={calculateHeight(props, height)}
          style={{ background: '#f9f9f9' }}
        />
      </div>
    )}
  </AutoSizer>
);

export default VirtualList;
